module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.36b5bab5.ttf";